// imports

// types
const SET_APP_CONTEXT = 'SET'
const APP_CONTEXT = 'context'

const state = {
  embedded: null, // or iframe
  source: null
}

const mutations = {
  [SET_APP_CONTEXT] (state, ctx) {
    state.embedded = ctx.embed
    state.source = ctx.source
  }
}

const getters = {
  [APP_CONTEXT] (state) { return state }
}

export default { namespaced: true, state, mutations, getters }
